(function () {
  "use strict";

  // Bazaarvoice ratings were removed. Keep the custom element so Retail Connect
  // product cards that still mount <rcc-product-card-reviews> do not error.
  class ProductCardReviewsComponent extends HTMLElement {
    set product(_value) {
      this.innerHTML = "";
    }

    connectedCallback() {
      this.innerHTML = "";
    }
  }

  if (!customElements.get("rcc-product-card-reviews")) {
    customElements.define("rcc-product-card-reviews", ProductCardReviewsComponent);
  }
})();
